import { ValueFormatterParams } from 'ag-grid-community';
import { formatValue, NumeralTypes } from '../numeral.component';

export const PercentageValueFormatter = (params: ValueFormatterParams) => formatValue({
  type: NumeralTypes.PERCENTAGE,
  value: params.value,
  customFormat: null,
  fixedPrecision: null,
  acceptRaw: false,
}) ?? '';

export const PercentageOrRawValueFormatter = (params: ValueFormatterParams) => formatValue({
  type: NumeralTypes.PERCENTAGE,
  value: params.value,
  customFormat: null,
  fixedPrecision: null,
  acceptRaw: true,
}) ?? '';
